import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Button } from "@mui/material";

import CircularProgress from "@mui/material/CircularProgress";
import ManageGameModal from "./Modals/ManageGameModal.jsx";

import RequestsSection from "./RequestsSection";
import WaitlistSection from "./WaitlistSection";
import CurrentPlayersSection from "./CurrentPlayersSection";

interface RootState {
  host: {
    gamelist: {
      [key: string]: {
        id: string;
        gameName: string;
        status: string;
        minPlayers: number;
        maxPlayers: number;
        waitlist: {
          [key: string]: any;
        };
        currentPlayers: {
          [key: string]: any;
        };
        gameSessionId?: string;
        hostId: string;
      };
    };
  };
}

function ManageGame() {
  const gamelist = useSelector((state: RootState) => state.host.gamelist);
  const [gameInfo, setGameInfo] = useState<
    RootState["host"]["gamelist"][string] | null
  >(null);

  const [modalDets, setModalDets] = useState({
    open: false,
    status: "",
  });

  const params = useParams<{ gameId: string }>();

  useEffect(() => {
    async function fetchMyAPI() {
      await setGameInfo(gamelist[params.gameId]);
    }
    fetchMyAPI();
  }, [gamelist, params.gameId]);

  const startGame = () => {
    if (!gameInfo) return;

    if (Object.keys(gameInfo.waitlist).length >= gameInfo.minPlayers) {
      setModalDets({
        ...modalDets,
        open: true,
        status: "startGame",
      });
    } else {
      setModalDets({
        ...modalDets,
        open: true,
        status: "error",
      });
      console.log(`Need at least ${gameInfo.minPlayers}players to start`);
    }
  };

  const delayGame = () => {
    setModalDets({
      ...modalDets,
      open: true,
      status: "delayGame",
    });
  };

  const endGame = () => {
    setModalDets({
      ...modalDets,
      open: true,
      status: "endGame",
    });
  };

  const renderStartEndGame = () => {
    if (!gameInfo) return null;

    switch (gameInfo.status) {
      case "Interest":
        return (
          <>
            <Button variant="danger" onClick={startGame}>
              Start Game
            </Button>
            <br />
            <Button variant="warning" onClick={delayGame}>
              Delay Game
            </Button>
          </>
        );
      case "Delayed":
        return (
          <Button variant="danger" onClick={startGame}>
            Start Game
          </Button>
        );
      // Running
      default:
        return (
          <Button variant="danger" onClick={endGame}>
            End Game
          </Button>
        );
    }
  };

  return (
    <div className="host">
      <ManageGameModal dets={modalDets} gameInfo={gameInfo} />
      {gameInfo ? (
        <>
          <h1>Manage Game {gameInfo.gameName}</h1>
          <h3>
            <span>Status: </span>
            <span style={{ color: "red" }}>{gameInfo.status}</span>
          </h3>
          <h4>
            <span>
              {gameInfo.minPlayers} - {gameInfo.maxPlayers} Players
            </span>
          </h4>
          <h4>
            <span>Players on Waitlist: </span>
            <span style={{ color: "red" }}>
              {Object.keys(gameInfo.waitlist).length}
            </span>
          </h4>
          <h4>
            <span>Players on Table: </span>
            <span style={{ color: "red" }}>
              {Object.keys(gameInfo.currentPlayers).length}
            </span>
          </h4>
          <br />

          {renderStartEndGame()}
          <br />
          <hr />

          <RequestsSection gameInfo={gameInfo} />
          <br />
          <hr />
          <WaitlistSection gameInfo={gameInfo} />
          <br />
          <hr />

          <CurrentPlayersSection gameInfo={gameInfo} />
          <br />
        </>
      ) : (
        <CircularProgress />
      )}
    </div>
  );
}

export default ManageGame;
